import React, { useEffect, useMemo, useCallback } from "react";
import { Card } from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";

//Custom components
import MenuButtons from "../PreviousConversations/subcomponents/MenuButtons";

//Redux
import { useSelector, useDispatch } from "react-redux";

// actions
import { getAditionalFields, resetApiAditionalFields, saveAditionalFields } from "../../../../store/aditionalFields/actions";
import AditionalFieldsForm from "./subcomponents/AditionalFieldsForm";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { getInteractions } from "../../../../store/interactions/actions";
import useHasPermission from "../../../../hooks/useHasPermission";

const AditionalFields = ({ t, chatId, update, moreOptions, moreOptionsVisible }) => {

    toastr.options = {
        closeButton: false,
        debug: false,
        newestOnTop: false,
        progressBar: true,
        positionClass: "toast-top-right",
        preventDuplicates: true,
        onclick: null,
        showDuration: "200",
        hideDuration: "200",
        timeOut: "2000",
        extendedTimeOut: "2000",
        showEasing: "swing",
        hideEasing: "linear",
        showMethod: "fadeIn",
        hideMethod: "fadeOut",
    };
 
    const showToast = useCallback((type, message) => {
        toastr[type](message);
    },[]);

    const { info: chatInfo, status } = useSelector(
        (state) => state.AditionalFields
    );

    const hasPermissionAditionalFieldsWrite = useHasPermission('additional_fields_widgets', 'post')

    const dataFields = useMemo(()=>{
        if(chatInfo[chatId]){
            return chatInfo[chatId];
        }
        return [];
    },[chatId, chatInfo]);
    

    const dispatch = useDispatch();


    useEffect(() => {
        if (chatId && (!chatInfo[chatId] || update)) {
          dispatch(getAditionalFields(chatId));
        }        
    }, [chatId, update, dispatch, chatInfo]);

    useEffect(()=>{
        if(status && status?.save_fields){
            const {error, success} = status?.save_fields;
            if(success){
                showToast('success', t(`Change successfully saved`));
                if(chatId){
                   dispatch(getInteractions(chatId)); 
                }
                dispatch(resetApiAditionalFields());
            }else if(error && error?.message){
                showToast('error', t(`${error?.message}`));
            }
        }
    },[status?.save_fields, chatId, status, showToast, t, dispatch]);

    const onSaveValues = useCallback((values)=>{        
        if(chatId){
          dispatch(saveAditionalFields(chatId, values)); 
        }               
    },[chatId, dispatch]);
   
    return(
        <Card className="user-chat h-100 client-info-card">
            <MenuButtons
                type="aditionalFields"
                chatId={chatId}
                enableMoreOptions = {moreOptionsVisible}
                moreOptions={{ options: moreOptions }}
                moreOpAction={(e) => {
                    moreOptions.find((element) => element.value === e)?.action();
                }}
            />
            <AditionalFieldsForm
                data={dataFields}                
                onSaveValues={onSaveValues}
                isLoading={status?.save_fields?.loading}
                hasPermissionAditionalFieldsWrite={hasPermissionAditionalFieldsWrite}
            />            
        </Card>
    );
}

export default withTranslation()(AditionalFields);